var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.getCss('default')] = !_vm.styles.image || !_vm.styles.image.src, _obj['csu-clickable'] =  _vm.clickable, _obj ),style:(_vm.styles.base),on:{"click":function($event){return _vm.handleClickEvent()},"mouseenter":function($event){return _vm.handleEvent('hover')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }